import React, { useEffect, useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { allapiAction } from "../Redux/common/action"; // Make sure this file is inside src
import { URL } from "../Redux/common/url";
import { toast } from "react-toastify";

export default function Branch() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [managerKey, setManagerKey] = useState(0);
  // 🔹 Base Public API URL
  const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/publicApi`;

  // 🔹 Redux selectors
  // const branchList =
  //     useSelector((state) => state?.allapi?.getAllBranchsListformain?.data) || [];

  // 🔹 State
  const [branchId, setBranchId] = useState("");
  const [branchList, setbranchList] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedSubBranch, setSelectedSubBranch] = useState(null);
  const [subOptions, setSubOptions] = useState([]);
  const [loadingSub, setLoadingSub] = useState(false);

  const [tncList, setTncList] = useState([]);
  const [selectedTncs, setSelectedTncs] = useState("");
  const [loadingTnc, setLoadingTnc] = useState(false);

  const [tokenuser, settokenuser] = useState("");
  const [tokenvendor, settokenverndorr] = useState("");
  useEffect(() => {
    if (branchId) {
      setManagerKey(managerKey + 1);
      setSelectedSubBranch(null);
    }

    return () => {};
  }, [branchId]);

  // 🔹 Initial Load
  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const tokenvn = localStorage.getItem("access_token_vendor");
    settokenuser(token);
    settokenverndorr(tokenvn);
    getData();
    // 🔸 Load branches from Redux

    // 🔸 Load Terms & Conditions
    // fetchTnc();
  }, []);

  const getData = async () => {
    const response = await dispatch(
      allapiAction.getAllBranchsListformain({ page: 1, totaldoc: 50 }),
    );
    const response1 = await dispatch(
      allapiAction.allTramsAndCondition({ page: 1, totaldoc: 50 }),
    );
    console.log(response);
    console.log(response1);

    if (response?.success) {
      setbranchList(response?.data);
    }

    if (response?.success) {
      setTncList(response1?.data);
    }
  };

  // 🔹 Fetch Terms
  const fetchTnc = async () => {
    setLoadingTnc(true);
    try {
      const res = await axios.get(`${BASE_URL}/allTramsAndCondition`);
      setTncList(res.data?.data || []);
    } catch (err) {
      console.error("Error loading T&C:", err);
    }
    setLoadingTnc(false);
  };

  // 🔹 Load Branch Options (from Redux)
  const loadBranchOptions = async (search, loadedOptions, { page }) => {
    const filtered =
      branchList
        ?.filter((b) => b.name?.toLowerCase()?.includes(search?.toLowerCase()))
        ?.map((b) => ({ value: b.id, label: b.name })) || [];

    return {
      options: filtered,
      hasMore: false,
      additional: { page: page + 1 },
    };
  };

  // 🔹 Handle Branch Select → Load Sub-Branches
  const handleBranchChange = async (selected) => {
    setSelectedBranch(selected);
    setSelectedSubBranch(null);
    setSubOptions([]);

    if (!selected) return;
    setLoadingSub(true);

    try {
      const res = await axios.post(`${BASE_URL}/getSubBranchsforuser`, {
        page: 1,
        branch_id: selected.value,
      });
      const subs =
        res.data?.data?.map((s) => ({
          value: s.id,
          label: s.name,
        })) || [];
      setSubOptions(subs);
    } catch (err) {
      console.error("Error loading sub-branches:", err);
    }
    setLoadingSub(false);
  };

  // 🔹 Load Sub-Branch Options (from state)
  // const loadSubBranchOptions = async (search, loadedOptions, { page }) => {
  //     const filtered =
  //         subOptions.filter((s) =>
  //             s.label.toLowerCase().includes(search.toLowerCase())
  //         ) || [];
  //     return {
  //         options: filtered,
  //         hasMore: false,
  //         additional: { page: page + 1 },
  //     };
  // };
  const loadSubBranchOptions = async (search, loadedOptions, pages) => {
    console.log(loadedOptions);
    console.log(pages);

    const response = await fetch(
      URL.API_BASE_URL +
        `/publicApi/getSubBranchsforuser?key=${search}&page=${pages?.page}&branch_id=${branchId}`,
    );
    const responseJSON = await response.json();

    const options = responseJSON?.results?.map((data) => {
      data.value = data?._id;
      data.label = data?.name;

      return data;
    });

    return {
      options: options,
      hasMore: responseJSON.has_more,
      additional: {
        page: pages?.page + 1,
      },
    };
  };
  // 🔹 Handle T&C Checkbox Toggle
  const handleTncToggle = (id) => {
    setSelectedTncs((prev) =>
      prev.includes(id) ? prev.filter((t) => t !== id) : [...prev, id],
    );
  };

  const [first2, setfirst2] = useState("");
  // 🔹 Submit Form
  const handleSubmit = async () => {
    console.log(branchId);
    console.log(selectedSubBranch);
    console.log(selectedTncs);

    if (!branchId) {
      // alert("कृपया सभी फ़ील्ड भरें।");

      toast?.error("please select branch");
      return;
    }
    if (!selectedSubBranch) {
      // alert("कृपया सभी फ़ील्ड भरें।");

      toast?.error("please select sub branch");
      return;
    }
    if (!first2) {
      toast?.error("please select branch type");
      return;
    }
    if (!selectedTncs) {
      // alert("कृपया सभी फ़ील्ड भरें।");

      toast?.error("please select tnc");
      return;
    }

    try {
      const payload = {
        BranchId: branchId,
        branchtype: first2,
        subBranchId: selectedSubBranch?._id,
        tremsAndConditionId: selectedTncs,
      };

      // const res = await axios.post(`${URL.API_BASE_URL}/submitBranchInquery`, payload);
      const res = await dispatch(allapiAction.submitBranchInquery(payload));
      if (res?.success) {
        // alert("Branch Inquiry सफलतापूर्वक सबमिट हो गई!");
        // toast?.success("Branch Inquiry सफलतापूर्वक सबमिट हो गई!");
        navigate("/");
      } else {
        // alert(res.data?.message || "कुछ गड़बड़ हो गई।");
        toast?.error(res?.message || "कुछ गड़बड़ हो गई।");
      }
    } catch (err) {
      console.error("Error submitting inquiry:", err);
      // alert("Inquiry सबमिट करते समय समस्या आई।");
      toast?.error("Inquiry सबमिट करते समय समस्या आई।");
    }
  };

  return (
  <div className="dddd container" style={{ marginTop: "80px", marginBottom: "80px" }}>
  <div className="d-flex justify-content-center align-items-center">
    <div className="card branch-form-card p-4 p-md-5">
      
      {/* Header */}
      <div className="text-center mb-4">
        <h3 className="fw-bold text-primary">Branch Inquiry</h3>
        <p className="text-muted small">Please fill in the details below</p>
      </div>

      <div className="form-body">
        {/* Branch Selection */}
        <div className="mb-4">
          <label className="form-label fw-bold"><i className="bi bi-building me-2"></i>Select Branch</label>
          <select
            name="banchId"
            className="form-select custom-select"
            value={branchId}
            onChange={(e) => setBranchId(e?.target?.value)}
          >
            <option value="">Choose a branch...</option>
            {branchList?.map((branch) => (
              <option key={branch._id} value={branch._id}>{branch.name}</option>
            ))}
          </select>
        </div>

        {/* Sub-Branch Selection */}
        {branchId && (
          <div className="mb-4 animate__animated animate__fadeIn">
            <label className="form-label fw-bold">Select Sub-Branch</label>
            <AsyncPaginate
              key={managerKey}
              value={selectedSubBranch}
              loadOptions={loadSubBranchOptions}
              onChange={setSelectedSubBranch}
              additional={{ page: 0 }}
              styles={{
                control: (base) => ({
                  ...base,
                  borderRadius: '8px',
                  padding: '2px'
                })
              }}
              placeholder={loadingSub ? "Loading..." : "Search sub-branch..."}
              isClearable
            />
          </div>
        )}

        {/* Branch Type */}
        <div className="mb-4">
          <label className="form-label fw-bold">Select Branch Type</label>
          <select
            className="form-select custom-select"
            value={first2}
            onChange={(e) => setfirst2(e?.target?.value)}
          >
            <option value="">Choose type...</option>
            <option value="Distributor">Distributor</option>
            <option value="Advisor">Advisor</option>
          </select>
        </div>

        {/* Terms & Conditions */}
        <div className="mb-4">
          <label className="form-label fw-bold">Terms & Conditions</label>
          <div className="tnc-container p-5 rounded-3" style={{ maxHeight: 180, overflowY: "auto" }}>
            {loadingTnc ? (
              <div className="text-center py-3 text-muted">
                <div className="spinner-border spinner-border-sm me-2"></div> Loading...
              </div>
            ) : (
              tncList.slice(0, 10).map((t, i) => (
                <div key={t._id || i} className="form-check tnc-item mb-2 ">
                  <input
                    className="form-check-input shadow-none"
                    type="radio"
                    id={`tnc-${i}`}
                    name="termsRadio"
                    checked={selectedTncs === t._id}
                    onChange={() => setSelectedTncs(t._id)}
                  />
                  <label className="form-check-label small" htmlFor={`tnc-${i}`}>
                    {t.description}
                  </label>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Submit Button */}
        <div className="d-grid mt-2">
          <button 
            className="btn btn-primary submit-btn shadow-sm" 
            onClick={handleSubmit}
            disabled={!branchId || !selectedTncs}
          >
            Submit Inquiry
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
  );
}
